<template>
  <labeled-form-control label="Any notes for us?">
    <textarea v-model="medicalNoteText" class="form-control" cols="50" placeholder="Add notes (optional)" rows="5"></textarea>
  </labeled-form-control>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LabeledFormControl from '@/components/Layout/LabeledFormControl.vue'

export default {
  name: 'ClientMedicalNote',
  computed: {
    ...mapGetters('ClientRegistrationUpload', [
      'findNote'
    ]),
    ownerTypeId () {
      return 2
    },
    noteTypeId () {
      return 3
    },
    note () {
      return this.findNote(this.ownerTypeId, this.noteTypeId)
    },
    medicalNoteText: {
      get () {
        return this.note?.noteText || ''
      },
      set (value) {
        this.setNoteText({ ownerTypeId: this.ownerTypeId, noteTypeId: this.noteTypeId, value })
      }
    }

  },
  methods: {
    ...mapMutations('ClientRegistrationUpload', [
      'setNoteText'
    ])
  },
  components: {
    'labeled-form-control': LabeledFormControl
  }
}
</script>
